export default {
  organizations: {
    switchOrganization: "Changer d'organisation",
    noOrganizations: 'Aucune organisation',
    createNew: 'Créer nouveau',
    selectOrganization: 'Sélectionner une organisation',
    members: 'membres',
    invite: 'Inviter',
    inviteSubtitle: 'Ajouter des membres',
    manageOrganizations: 'Gérer les organisations',
    create: {
      title: 'Créer une organisation',
      confirmButton: "Créer l'organisation",
      nameLabel: "Nom de l'organisation",
      namePlaceholder: "Entrez le nom de l'organisation",
      nameRequired: "Le nom de l'organisation est requis",
      nameTooShort: 'Le nom doit contenir au moins 2 caractères',
      nameTooLong: 'Le nom doit contenir moins de 100 caractères',
      slugLabel: 'Slug URL',
      slugPlaceholder: 'organisation-slug',
      slugHint: 'Utilisé dans les URLs et doit être unique',
      slugRequired: 'Le slug est requis',
      slugInvalid:
        'Le slug ne peut contenir que des lettres minuscules, des chiffres et des tirets',
      slugTooShort: 'Le slug doit contenir au moins 3 caractères',
      slugTooLong: 'Le slug doit contenir moins de 50 caractères',
      legalSection: 'Informations légales (Optionnel)',
      legalNameLabel: 'Nom légal',
      taxIdLabel: 'Numéro de TVA',
      addressLabel: 'Adresse',
      countryLabel: 'Pays',
      contactSection: 'Informations de contact (Optionnel)',
      contactEmailLabel: 'Email de contact',
      contactPhoneLabel: 'Téléphone de contact',
      websiteLabel: 'Site web',
      emailInvalid: 'Veuillez entrer une adresse email valide',
      websiteInvalid: 'Veuillez entrer une URL valide commençant par http:// ou https://',
      createFailed: "Échec de la création de l'organisation. Veuillez réessayer.",
    },
  },
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    create: 'Créer',
    search: 'Rechercher',
    filter: 'Filtrer',
    loading: 'Chargement...',
    noResults: 'Aucun résultat trouvé',
    error: 'Erreur',
    success: 'Succès',
    confirm: 'Confirmer',
    close: 'Fermer',
    back: 'Retour',
    next: 'Suivant',
    continue: 'Continuer',
    previous: 'Précédent',
    yes: 'Oui',
    no: 'Non',
    ok: 'OK',
    actions: 'Actions',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    profile: 'Profil',
    help: 'Aide',
    about: 'À propos',
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    notifications: 'Notifications',
    retry: 'Réessayer',
    theme: {
      light: 'Clair',
      dark: 'Sombre',
      system: 'Système',
      title: 'Thème',
      lightTooltip: 'Thème clair',
      darkTooltip: 'Thème sombre',
      systemTooltip: 'Suivre les préférences système'
    },
    docs: 'Documentation',
    all: 'Tout',
    peak: 'Pic',
    total: 'Total',
    selectAll: 'Tout sélectionner',
    selectNone: 'Tout désélectionner',
    others: 'autres',
    apply: 'Appliquer'
  },
  dateRangePicker: {
    title: 'Période',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    quickShortcuts: 'Raccourcis rapides',
    shortcuts: {
      today: 'Aujourd\'hui',
      yesterday: 'Hier',
      last7Days: '7 derniers jours',
      last30Days: '30 derniers jours',
      thisMonth: 'Ce mois-ci',
      lastMonth: 'Mois dernier',
      thisYear: 'Cette année',
      lastYear: 'Année dernière'
    }
  },
  errors: {
    general: 'Une erreur est survenue',
    notFound: 'Non trouvé',
    unauthorized: 'Non autorisé',
    forbidden: 'Interdit',
    serverError: 'Erreur serveur',
    networkError: 'Erreur réseau',
    validationError: 'Erreur de validation',
    system: {
      title: "Une erreur s'est produite",
      message: 'Nous avons rencontré une erreur inattendue. Veuillez réessayer plus tard.',
      code: "Code d'erreur",
    },
  },
  validation: {
    required: 'Ce champ est requis',
    email: 'Veuillez entrer un email valide',
    minLength: 'La longueur minimale est {min}',
    maxLength: 'La longueur maximale est {max}',
    pattern: 'Format invalide',
  },
  modals: {
    deleteConfirmation: {
      warning: 'Attention',
      cannotUndo: 'Cette action ne peut pas être annulée.',
      defaultMessage: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    },
  },
  userDrawer: {
    quickActions: 'Actions rapides',
    organizations: 'Organisations',
    notifications: 'notifications',
    orgs: 'orgs',
    role: {
      admin: 'Administrateur',
      user: 'Utilisateur'
    },
    shortcuts: {
      subscription: 'Mon forfait',
      subscriptionTooltip: 'Gérer votre abonnement',
      invoices: 'Factures',
      invoicesTooltip: 'Voir et télécharger les factures',
      help: "Centre d'aide",
      helpTooltip: 'Obtenir de l\'aide et du support',
      tickets: 'Assistance',
      ticketsTooltip: 'Voir les tickets de support',
      team: 'Équipe',
      teamTooltip: 'Gérer les membres de l\'équipe',
      api: 'API',
      apiTooltip: 'Accéder à la documentation API'
    },
    settings: {
      title: 'Paramètres',
      profile: 'Paramètres personnels',
      security: 'Paramètres de sécurité',
      organization: "Paramètres de l'organisation"
    }
  },
  apps: {
    home: {
      title: 'Accueil',
      description: 'Page d\'accueil'
    },
    dashboard: {
      title: 'Tableau de bord',
      description: 'Rapports et analyses des incidents et actions'
    },
    'production-lines': {
      title: 'Lignes de production',
      description: 'Gestion des lignes de production industrielles'
    },
    incidents: {
      title: 'Incidents',
      description: 'Système de gestion des incidents'
    },
    actions: {
      title: 'Actions',
      description: 'Gestion des actions pour la réponse aux incidents'
    },
    mediasbox: {
      title: 'Mediasbox',
      description: 'Importez et mettez en ligne vos médias'
    },
    channels: {
      title: 'Channels',
      description: 'Créez un site avec vos médias'
    },
    scribe: {
      title: 'Scribe',
      description: 'Sous-titrez automatiquement vos vidéos'
    },
    showcases: {
      title: 'Showcase',
      description: 'Créez une page attrayante à partager'
    },
    analytics: {
      title: 'Analytics',
      description: 'Mesurez l\'impact de vos vidéos'
    },
    streams: {
      title: 'Streams',
      description: 'Diffusion vidéo en direct avec chat'
    },
    studio: {
      title: 'Studio',
      description: 'Génération de vidéos par IA'
    },
    record: {
      title: 'Record',
      description: 'Enregistrez l\'écran ou la caméra'
    },
    playground: {
      title: 'Playground',
      description: 'Zone de test et développement'
    }
  },
  upload: {
    title: 'Téléversements',
    browseFiles: 'Parcourir les fichiers',
    dropZone: {
      title: 'Glissez-déposez vos fichiers ici',
      subtitle: 'ou cliquez pour parcourir'
    },
    stats: {
      total: 'Total',
      active: 'Actifs',
      completed: 'Terminés'
    },
    actions: {
      startAll: 'Tout démarrer',
      clearCompleted: 'Effacer terminés',
      clearAll: 'Tout effacer'
    },
    status: {
      pending: 'En attente',
      uploading: 'En cours',
      paused: 'En pause',
      completed: 'Terminé',
      error: 'Erreur'
    },
    empty: 'Aucun téléversement',
    errorDetails: 'Détails de l\'erreur',
    hint: 'Vous pouvez aussi glisser-déposer des fichiers n\'importe où sur la page',
    overlay: {
      title: 'Déposez les fichiers pour les téléverser',
      subtitle: 'Relâchez pour démarrer le téléversement'
    }
  }
}
